import React from "react";
import classnames from "classnames";

import "./index.scss";

const HorizontalDivider = () => <div className={classnames("horizontal-divider")} />;

export default HorizontalDivider;
